import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, signUpProfessional } from "../../Utils/Constants";

export const hitSignUpProfessionalApi = createAsyncThunk(
  "hitSignUpProfessionalApi",
  async (payload) => {
    try {
      const requestPayload = {
        ...payload,
        serviceIds: Array.isArray(payload?.serviceIds)
          ? payload.serviceIds.filter(Boolean)
          : payload?.serviceIds
            ? [payload.serviceIds]
            : [],
      };

      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const url = ApiBaseUrl + signUpProfessional;
      const response = await axios.post(url, requestPayload, config);
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },
);

const signUpProfessionalSlice = createSlice({
  name: "signUpProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearSignUpProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSignUpProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSignUpProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitSignUpProfessionalApi.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { clearSignUpProfessionalData } = signUpProfessionalSlice.actions;
export default signUpProfessionalSlice.reducer;
